<script lang="ts" setup>
    import { type TextMessage, type Status as Tab, type TextMessageStatus } from '../TextMessagesTypes';
    import TextMessageHeader from './Components/TextMessageHeader.vue';
    import TextMessageEventInfo from './Components/TextMessageEventInfo.vue';
    import TextMessageMeta from './Components/TextMessageMeta.vue';
    import TextMessageStatusActions from './Components/TextMessageStatusActions.vue';
    import TextMessageProgressBars from './Components/TextMessageProgressBars.vue';

    const props = defineProps<{
        textMessage: TextMessage;
        currentTab?: Tab;
    }>();

    const emit = defineEmits<{
        'update:status': [data: { id: string; status: TextMessageStatus }];
        abortSending: [id: string];
    }>();

    const draftStatus = 10;
    const sentStatus = 3;

    const handleUpdateStatus = (status: TextMessageStatus) => {
        emit('update:status', {
            id: props.textMessage.SmsMessageId,
            status,
        });
    };

    const handleAbortSending = () => {
        emit('abortSending', props.textMessage.SmsMessageId);
    };

    const handleMoveToDrafts = () => {
        handleUpdateStatus(draftStatus);
    };

    const handleMoveToSent = () => {
        handleUpdateStatus(sentStatus);
    };
</script>

<script lang="ts"></script>

<template>
    <div class="flex-1" style="min-width: min(400px, 100%)">
        <TextMessageHeader
            :textMessage="textMessage"
            :to="currentTab === 'sent' ? { name: 'TextMessageStatistics', params: { smsMessageId: textMessage.SmsMessageId } } : undefined"
            :href="'/TextMessages/' + textMessage.SmsMessageId" />

        <TextMessageEventInfo :textMessage="textMessage" />

        <TextMessageMeta :textMessage="textMessage" />
    </div>

    <TextMessageStatusActions
        :textMessage="textMessage"
        :currentTab="currentTab"
        @moveToDrafts="handleMoveToDrafts"
        @moveToSent="handleMoveToSent"
        @abortSending="handleAbortSending" />

    <TextMessageProgressBars :textMessage="textMessage" :currentTab="currentTab" />
</template>
